import companyService from './companyService'

export default companyService
